export default "__VITE_ASSET__BJNLKKIq__"